export const BASE_W = 1080;
export const BASE_H = 1920;

export const COLORS = {
  bg: 0x0f172a,
  panel: 0x1e293b,
  accent: 0x22d3ee,
  good: 0x34d399,
  bad: 0xf87171,
  warn: 0xfbbf24,
  text: 0xffffff,
  textDim: 0x94a3b8,
  tilePalette: [0x6366f1, 0xec4899, 0xf59e0b, 0x10b981, 0x06b6d4, 0xa855f7, 0xef4444, 0x84cc16]
} as const;

export const TILE_SIZE = 220;
export const DOT_SIZE_MIN = 14;
export const DOT_SIZE_MAX = 22;
export const TILE_INNER_PADDING = 24;

export const SCORE = {
  base: 100,
  comboStep: 0.1,
  comboMax: 3.0,
  speedBonusMax: 1.0
};

export const STORAGE_KEYS = {
  nickname: 'mn:nickname',
  muted: 'mn:muted',
  bestScore: 'mn:bestScore',
  localUid: 'mn:localUid',
  installVisits: 'mn:installVisits',
  installDismissed: 'mn:installDismissed'
} as const;

export const INSTALL_PROMPT_MAX_VISITS = 3;

export const MAX_LIVES = 3;
export const TOTAL_LEVELS = 60;
